// extracted by mini-css-extract-plugin
export var backgroundImage = "HeadlineBanners-module--backgroundImage--67e7d";
export var bannerContainer = "HeadlineBanners-module--bannerContainer--54b4a";
export var bannersContainer = "HeadlineBanners-module--bannersContainer--644b2";
export var headlineContainerCenter = "HeadlineBanners-module--headlineContainerCenter--dcd1f";
export var headlineContainerLeft = "HeadlineBanners-module--headlineContainerLeft--84567";
export var headlineContainerRight = "HeadlineBanners-module--headlineContainerRight--16f60";
export var veilOfDarkness = "HeadlineBanners-module--veilOfDarkness--07444";